import { Component } from '@angular/core';
import { LegendComponent, LegendPosition } from '@realpage-da/ng-map';
import { MARKET_BOUNDARY_STYLE, SUBMARKET_BOUNDARY_STYLE } from '~/main/constants';


@Component({
  selector: 'property-legend',
  templateUrl: './property-legend.component.html',
  styleUrls: ['./property-legend.component.scss']
})
export class PropertyLegendComponent extends LegendComponent {

  legendPosition: LegendPosition = LegendPosition.LEFT_BOTTOM;

  marketBoundaryStyle = {
    'border-style': 'solid',
    'border-width': '2px',
    'border-color': MARKET_BOUNDARY_STYLE.color,
    'margin': '0.25rem'
  };

  submarketBoundaryStyle = {
    'border-style': 'solid',
    'border-width': '2px',
    'border-color': SUBMARKET_BOUNDARY_STYLE.color,
    'margin': '0.25rem'
  };

}



// WEBPACK FOOTER //
// ./src/app/features/property/components/map/property-legend.component.ts